module.exports = __webpack_public_path__ + "static/media/not-found.4cfb3b7d.jpg";